export enum ControlType {
  TextField,
  TextArea,
  Select,
  DatePicker,
  TimePicker,
  AddressSearch,
  ImageCapture,
  SelectMulti,
  SelectCreate,
  Switch,
  VehicleCheckOption,
  DayOfTheWeekPicker,
}
